import { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { DEFAULT_WIDTH } from '..'
import { ASPECT_RATIO } from '../index'
import { ZoomMakerFrame } from '../types'

const Canvas = styled.canvas`
    display: block;
    height: 100%;
    width: 100%;
`

type Props = {
    frames: ZoomMakerFrame[]
    paused?: boolean
}

const ZoomMakerCanvasPreview = ({ frames, paused = false }: Props) => {
    const canvasRef = useRef<HTMLCanvasElement>(null)

    useEffect(() => {
        if (!canvasRef.current) return

        const canvas = canvasRef.current
        const context = canvas.getContext('2d')
        let lastDraw = 0
        let frame = 0
        let animation = 0
        const draw = (time) => {
            canvas.width = DEFAULT_WIDTH
            canvas.height = DEFAULT_WIDTH / ASPECT_RATIO
            context?.putImageData(frames[frame].data, 0, 0)
            if (time - lastDraw >= frames[frame].delay) {
                frame++
                frame = frame % frames.length
                lastDraw = time
            }
            if (!paused) {
                animation = requestAnimationFrame(draw)
            }
        }
        draw(performance.now())
        return () => {
            cancelAnimationFrame(animation)
        }
    }, [canvasRef, paused, frames])

    return <Canvas ref={canvasRef} style={paused ? { filter: 'grayscale(100%)', opacity: 0.8 } : {}} />
}

export default ZoomMakerCanvasPreview
